import React, { Component } from 'react';
import axios from 'axios';


import {
  NavLink,
  Redirect
} from 'react-router-dom';


class CevaplarColchicum extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      date: '',
      sunum01: [],
      sunum02: [],
      sunum03: []
    }
  }

  componentDidMount() {
  
  const sonuc19 = 19;
  const sonuc24 = 24;
  const sonuc11 = 11;

    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
  	const postId = location.pathname.split("/")[2];
  	//console.log(postId);
  
        var url01 = 'https://rarefocusapi.f5proje.com/colchicum-sonuc-01/' + postId;
        fetch(url01)
            .then(response01 => response01.json())
            .then(data01 => this.setState({
                sunum01: data01
            }));
        var url02 = 'https://rarefocusapi.f5proje.com/colchicum-sonuc-02/' + postId;
        fetch(url02)
            .then(response02 => response02.json())
            .then(data02 => this.setState({
                sunum02: data02
            }));
        var url03 = 'https://rarefocusapi.f5proje.com/colchicum-sonuc-03/' + postId;
        fetch(url03)
            .then(response03 => response03.json())
            .then(data03 => this.setState({
                sunum03: data03
            }));

        }


        render() {
	// soru 01
                const {
                    sunum01
                } = this.state;
                let outputData01 = sunum01.map((item) => {
                    return {
                        cevap01: parseInt(item.cevap),
                    };
                });
                console.log("outputData01:", outputData01);
        
                const result01 = Object.values(outputData01).reduce(
                    (r, {
                        cevap01
                    }) => r + cevap01,0
                );
                console.log("result01:", result01);
        
        
                const longeur01 = sunum01.length;
                console.log("longeur01:", longeur01);
        
                let sonuc01 = 100 - (result01 * 100) / longeur01;
        
                console.log("Soru10 yanlis orani:", sonuc01);
        
        
	  // soru 02
                  const {
                    sunum02
                } = this.state;
                let outputData02 = sunum02.map((item) => {
                    return {
                        cevap02: parseInt(item.cevap),
                    };
                });
                const result02 = Object.values(outputData02).reduce(
                    (r, {
                        cevap02
                    }) => r + cevap02,
                    0
                );
        
                console.log("outputData02:", outputData02);
                console.log("result02:", result02);

        
                const longeur02 = sunum02.length;
                let sonuc02 = 100 - (result02 * 100) / longeur02;
                console.log("Soru02 yanlis orani:", sonuc02);
	  // soru 03
                  const {
                    sunum03
                } = this.state;
                let outputData03 = sunum03.map((item) => {
                    return {
                        cevap03: parseInt(item.cevap),
                    };
                });
                const result03 = Object.values(outputData03).reduce(
                    (r, {
                        cevap03
                    }) => r + cevap03,
                    0
                );
                const longeur03 = sunum03.length;
                let sonuc03 = 100 - (result03 * 100) / longeur03;
                console.log("Soru03 yanlis orani:", sonuc03);

  
      var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {

    return (
    
    
    
      <div className="row pt-5">
          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success mb-1">Yanlış Cevap Yüzdesi</div>
              </div>
              <div className="list-group mb-3">
                  <br />
                  <div className="list-group-item list-group-item-action">
                      Soru 1 : {Number.isNaN(sonuc01) ? "Henüz soru cevaplanmadı" : `Yüzde: ${sonuc01.toFixed(2)} - Toplam cevap sayısı: ${longeur01}`}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 2 : {Number.isNaN(sonuc02) ? "Henüz soru cevaplanmadı" : `Yüzde: ${sonuc02.toFixed(2)} - Toplam cevap sayısı: ${longeur02}`}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 3 : {Number.isNaN(sonuc03) ? "Henüz soru cevaplanmadı" : `Yüzde: ${sonuc03.toFixed(2)} - Toplam cevap sayısı: ${longeur03}`}
                  </div>
              </div>
          </div>


          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success mb-1">Elocta Sorular ve Cevaplar</div>
              </div>
              <div className="list-group mb-3">
              
                  <div className="p-2">


                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">1. </span>
                                    <span class="fieldset-legend">Uzun dönem profilaksi için tavsiye edilen doz miktarı ne olmalıdır?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Haftada bir 10 IU/kg sabit doz</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Ayda bir 100 IU/kg tek doz uygulama</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Günlük 5 IU/kg düşük doz idame tedavisi</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">3,4,5 günde bir 50 IU/kg</div>
                                    </div>
                                </div>
                            </div>




                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">2. </span>
                                    <span class="fieldset-legend">Elocta nerelerde endikedir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Hemofili B tedavisinde</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Von Willebrand hastalığında</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Derin ven trombozu (DVT) profilaksisinde</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Hemofili A hastalarında görülen kana epizotlarının tedavisi ve profilaksisi</div>
                                    </div>
                                </div>
                            </div>




                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">3. </span>
                                    <span class="fieldset-legend">Hemofili hastaları için en büyük morbidite nedeni nedir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Akut böbrek yetmezliği</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Pulmoner emboli</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Miyokard enfarktüsü</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Kronik artropati</div>
                                    </div>
                                </div>
                            </div>


                  </div>
              
              </div>

          
          </div>




      </div>

    
    
    
    
    );
    } else {
        return (
          <div className="row top-buffer">
        	<Redirect to="/user/login" />
          </div>
        );
    }



  }
}

export default CevaplarColchicum



// WEBPACK FOOTER //
// src/components/cevaplar-elocta.jsx